<div class="container-fluid">
    <app-pagetitle title="Analytics & Reports" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

   <ul class="nav nav-tabs analytics-tabs mb-4">

    <li class="nav-item">
        <a class="nav-link"
           [class.active]="selectedTab === 'api'"
           (click)="selectTab('api')">
            API Performance
        </a>
    </li>

    <li class="nav-item">
        <a class="nav-link"
           [class.active]="selectedTab === 'project'"
           (click)="selectTab('project')">
            Project Health
        </a>
    </li>

    <li class="nav-item">
        <a class="nav-link"
           [class.active]="selectedTab === 'error'"
           (click)="selectTab('error')">
            Error Monitoring
        </a>
    </li>

    <li class="nav-item">
        <a class="nav-link"
           [class.active]="selectedTab === 'security'"
           (click)="selectTab('security')">
            Security & Access
        </a>
    </li>

</ul>

    <div *ngIf="selectedTab === 'api'">
        <iframe [src]="apiPerformanceUrl" width="100%" height="800" class="rounded"></iframe>
    </div>

    <div *ngIf="selectedTab === 'project'">
        <iframe [src]="projectHealthUrl" width="100%" height="800" class="rounded"></iframe>
    </div>

    <div *ngIf="selectedTab === 'error'">
        <iframe [src]="errorUrl" width="100%" height="800" class="rounded"></iframe>
    </div>

    <div *ngIf="selectedTab === 'security'">
        <iframe [src]="securityAccessUrl" width="100%" height="800" class="rounded"></iframe>
    </div>
</div>

<!-- <div class="container-fluid">
    <app-pagetitle title="Analytics & Reports" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

    <div class="row">
        <div class="col-xl-12">
            <div class="row">
                @for(stat of statData;track $index){
                <div class="col-md-3">
                    <app-stat [title]="stat.title" [value]="stat.value"></app-stat>
                </div>
                }
            </div>
        </div>
    </div>

    <div class="row g-4">
        <div class="col-lg-6 d-flex">
            <div class="card flex-fill">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <p class="fw-bold fs-5 mb-0">Platform Configuration</p>
                </div>
                <div class="card-body d-flex">
                    <div class="row w-100">

                        <div class="row mb-3" *ngFor="let status of documentStatusStats">
                            <div class="col-12 mb-1 d-flex justify-content-between">
                                <span class="fw-semibold">
                                    {{ status.label }}
                                </span>
                                <span class="text-muted">
                                    {{ status.count }} ({{ status.percentage }}%)
                                </span>
                            </div>

                            <div class="col-12">
                                <div class="progress" style="height: 8px;">
                                    <div class="progress-bar" [ngClass]="status.color" role="progressbar"
                                        [style.width.%]="status.percentage" [attr.aria-valuenow]="status.percentage"
                                        aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <div class="col-lg-6 d-flex">
            <div class="card flex-fill">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <p class="fw-bold fs-5 mb-0">Revenue by Plan</p>
                </div>
                <div class="card-body d-flex">
                    <div class="row w-100">

                        <div class="row mb-3" *ngFor="let plan of planUsage">
                            <div class="col-12 mb-1 d-flex justify-content-between">
                                <span class="fw-semibold">
                                    {{ plan.name }}
                                </span>
                                <span class="text-muted">
                                    {{ plan.count }} ({{ plan.percentage }}%)
                                </span>
                            </div>

                            <div class="col-12">
                                <div class="progress" style="height: 8px;">
                                    <div class="progress-bar" [ngClass]="plan.color" role="progressbar"
                                        [style.width.%]="plan.percentage" [attr.aria-valuenow]="plan.percentage"
                                        aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title mb-4">Top Customers by Usage</h4>

                    <div *ngIf="loading" class="text-center fw-bold">
                        Loading data...
                    </div>

                    <div class="table-responsive" *ngIf="!loading && customerStats && customerStats.length">
                        <table class="table table-centered align-middle">
                            <thead class="table-light">
                                <tr>
                                    <th>#Rank</th>
                                    <th>Customer Name</th>
                                    <th>Plan</th>
                                    <th>Documents</th>
                                    <th>MRR</th>
                                    <th>API Calls</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let customer of customerStats">
                                    <td class="fw-semibold">{{ customer.rank }}</td>

                                    <td>{{ customer.customerName }}</td>

                                    <td>
                                        <span class="badge" [ngClass]="{
                'bg-primary-subtle text-primary': customer.plan === 'Enterprise',
                'bg-success-subtle text-success': customer.plan === 'Growth',
                'bg-secondary-subtle text-secondary': customer.plan === 'Starter'
              }">
                                            {{ customer.plan }}
                                        </span>
                                    </td>

                                    <td>{{ customer.documents }}</td>

                                    <td>
                                        {{ customer.mrr | currency:'INR':'symbol':'1.0-0' }}
                                    </td>

                                    <td>{{ customer.apiCalls | number }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div *ngIf="!loading && (!customerStats || customerStats.length === 0)" class="fw-bold text-center">
                        No customer usage data found.
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->